<template>
  <v-btn
    color="error"
    @click="handleClick"
  >
    {{ $t('common.DELETE') }}
  </v-btn>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit("click")
    },
  },
}
</script>
